module.exports = __webpack_public_path__ + "static/media/card-view.c1e13105.svg";